import { useRef } from "react";
import { FileImage } from "@/components/files/FileFields";
import { fmtNum } from "@/lib/format";

export const DEFAULT_ROOM = "default";

function DefaultRoom() {
  return (
    <div className="absolute inset-0" data-testid="room-default">
      <div className="absolute inset-x-0 top-0 h-[62%] bg-[linear-gradient(180deg,#F2E9DC_0%,#E6D8C4_100%)]" />
      <div className="absolute inset-x-0 bottom-0 h-[38%] bg-[linear-gradient(180deg,#B88A5B_0%,#8F6239_100%)]" style={{ backgroundImage: "repeating-linear-gradient(90deg, rgba(0,0,0,.08) 0 2px, transparent 2px 90px), linear-gradient(180deg,#B88A5B,#8F6239)" }} />
      <div className="absolute left-[8%] top-[14%] w-[22%] h-[36%] bg-[linear-gradient(180deg,#CFE6F7,#9FC8E8)] border-[6px] border-white/80 shadow-lg" />
      <div className="absolute inset-x-0 top-[62%] h-1.5 bg-black/15" />
    </div>
  );
}

export function RoomStage({ room, items, products, src, editable = false, selected, onSelect, onMove, currency, showPrices = true, className = "", stageRef }) {
  const ref = useRef(null);
  const el = stageRef || ref;
  const drag = useRef(null);
  const down = (e, i) => {
    if (!editable) return;
    e.preventDefault(); onSelect?.(i);
    const r = el.current.getBoundingClientRect();
    drag.current = { i, dx: (e.clientX - r.left) / r.width * 100 - items[i].x, dy: (e.clientY - r.top) / r.height * 100 - items[i].y };
    e.currentTarget.setPointerCapture?.(e.pointerId);
  };
  const move = (e) => {
    if (!drag.current) return;
    const r = el.current.getBoundingClientRect();
    onMove?.(drag.current.i, { x: Math.round(((e.clientX - r.left) / r.width * 100 - drag.current.dx) * 10) / 10, y: Math.round(((e.clientY - r.top) / r.height * 100 - drag.current.dy) * 10) / 10 });
  };
  const up = () => { drag.current = null; };
  const Img = ({ id, alt, cls }) => (src ? <img src={src(id)} alt={alt} className={cls} draggable={false} /> : <FileImage id={id} alt={alt} className={cls} />);
  return (
    <div ref={el} onPointerMove={move} onPointerUp={up} onPointerLeave={up} className={`relative overflow-hidden rounded-2xl bg-black select-none ${className}`} style={{ aspectRatio: "16 / 10" }} data-testid="room-stage">
      {room && room !== DEFAULT_ROOM ? <Img id={room} alt="" cls="absolute inset-0 w-full h-full object-cover" /> : <DefaultRoom />}
      {items.map((it, i) => {
        const p = products?.[it.product_id];
        const img = it.image_id || p?.image_id;
        if (!img) return null;
        return (
          <div key={it.id} onPointerDown={(e) => down(e, i)} className={`room-item ${it.multiply ? "multiply" : ""} ${editable && selected === i ? "selected" : ""}`} style={{ left: `${it.x}%`, top: `${it.y}%`, width: `${it.w}%`, transform: `translate(-50%, -50%) rotate(${it.rot || 0}deg) scaleX(${it.flip ? -1 : 1})`, zIndex: 10 + i }} data-testid="room-item">
            <Img id={img} alt={p?.name || ""} cls="w-full h-auto block" />
            {showPrices && p && <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-white/95 text-[#1A2733] px-3 py-1 text-xs font-black shadow" style={{ transform: `translateX(-50%) scaleX(${it.flip ? -1 : 1})` }} dir="ltr" data-testid="room-item-price">{p.name} · {fmtNum(p.price)} {currency || ""}</div>}
          </div>
        );
      })}
    </div>
  );
}
